import { render, staticRenderFns } from "./media-releases.vue?vue&type=template&id=41d2c237&scoped=true"
import script from "./media-releases.vue?vue&type=script&lang=js"
export * from "./media-releases.vue?vue&type=script&lang=js"
import style0 from "./media-releases.vue?vue&type=style&index=0&id=41d2c237&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d2c237",
  null
  
)

export default component.exports